import React from 'react'
import PropTypes from 'prop-types'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  OptionCounterparty,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Trade.style'
import { Box, Typography } from '@mui/material'
import { ButtonGroupStyle, OptionContainer, PutCallButton, SideButton } from '../../Trade.style'
import FlagCurrency from '../../../../components/FlagCurrency/FlagCurrency'
import CurrencyLogo from '../../../../components/CurrencyLogo/CurrencyLogo'
import NumericFormatModal from '../../../../components/ModalApp/components/NumericFormatModal/NumericFormatModal'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import { CheckboxStyle, Label } from '../../../../components/styled/global.style'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import { FormControlLabelStyle } from '../../../Entities/Entities.style'

const VanillaTrade = ({
  counterParty,
  form,
  putCall,
  cut,
  sides,
  fixingSource,
  currencyData,
  handelFormChange,
  handelDateChange,
  disabledField,
  children,
  errors,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair,
  currencyInitial,
  tradingAccountTradersNormalize,
  checkPrimeBrokerIsRBS
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>
      <Box></Box>
      <Box width={'100%'}>
        <Label>Counterparty *</Label>
        {Array.isArray(counterParty.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'counterparty'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.counterparty}
            options={counterParty.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select CP'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>{form.trade_type.name.includes('Client') ? 'Client' : 'Our'} Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="side"
                key={id}
                value={name}
                select={String(form.side === name)}
                onClick={handelFormChange}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Put/Call *</Label>
        {Array.isArray(putCall) && (
          <ButtonGroupStyle variant="outlined">
            {putCall.map(({ name }, id) => (
              <PutCallButton
                name="put_call"
                key={id}
                disabled={disabledField.put_call}
                value={name}
                select={String(form.put_call === name)}
                onClick={handelFormChange}
              >
                {name}
              </PutCallButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Expiry Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.expiry}
          onChange={event => handelDateChange('expiry', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <NumericFormatModal
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Strike Price *</Label>
        <InputBaseStyle
          value={form.strike}
          name="strike"
          disabled={disabledField.strike}
          onChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      {Array.isArray(cut.data) && (
        <Box width={'100%'}>
          <Label>Cut *</Label>
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'cut'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.cut}
            options={cut.data.map(({ cut }) => cut)}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Cut" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        </Box>
      )}
      <Box width={'100%'}>
        <Label>Settlement Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.settlement_date}
          onChange={event => handelDateChange('settlement_date', event.target.value)}
        />
      </Box>
      {Array.isArray(currencyData.data) && (
        <Box width={'100%'}>
          <Label>Premium Currency *</Label>

          <AutocompleteStyle
            fullWidth
            onChange={(event, element) => {
              event.target.name = 'premium_currency'
              element = element ?? currencyInitial
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.premium_currency}
            getOptionLabel={option => option.name}
            options={currencyData.data}
            renderOption={(props, option) => (
              <OptionContainer {...props} key={option.id}>
                <FlagCurrency countryCode={option.code3} />
                <CurrencyLogo currencyCode={option.name} />
                <Typography>{option.name} </Typography>
              </OptionContainer>
            )}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Currency" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        </Box>
      )}
      {Array.isArray(fixingSource.data) && (
        <Box width={'100%'}>
          <Label>Fixing Source </Label>
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'fixing_source'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.fixing_source}
            disabled={disabledField.fixing_source}
            options={fixingSource.data.map(({ name }) => name)}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Fix Source" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        </Box>
      )}

      <Box width={'100%'}>
        <Label>Premium Amount *</Label>
        <InputBaseStyle
          value={form.premium_amount}
          name="premium_amount"
          onChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>

      <Box width={'100%'}>
        <Label>Premium Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.premium_date}
          onChange={event => handelDateChange('premium_date', event.target.value)}
        />
      </Box>

      <Box width={'100%'}>
        <Label>Trader </Label>
        {tradingAccountTradersNormalize.status === 200 && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'trader_name'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.trader_name}
            disabled={
              form.counterparty === '' ||
              !Array.isArray(tradingAccountTradersNormalize.data[form.counterparty]) ||
              tradingAccountTradersNormalize.data[form.counterparty].length === 0
            }
            getOptionLabel={option => option}
            options={
              form.counterparty !== '' &&
              Array.isArray(tradingAccountTradersNormalize.data[form.counterparty])
                ? tradingAccountTradersNormalize.data[form.counterparty].map(
                    trader_name => trader_name
                  )
                : []
            }
            renderInput={params => (
              <TextFieldModalStyle {...params} fullWidth placeholder="Select Trader" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Note</Label>
        <TextFieldStyle
          variant="outlined"
          value={form.note}
          name="note"
          onChange={handelFormChange}
        />
      </Box>
      {children}
      {checkPrimeBrokerIsRBS && (
        <>
          <Box width={'100%'}>
            <Label>Bdr</Label>
            <InputBaseStyle value={form.bdr} name="bdr" onChange={handelFormChange} />
          </Box>
          <Box
            style={{
              display: 'flex',
              margin: 'inherit'
            }}
          >
            <FormControlLabelStyle
              onChange={handelFormChange}
              name="is_pba"
              style={{ color: 'white' }}
              control={
                <CheckboxStyle
                  style={{ marginRight: '8px' }}
                  checked={form.is_pba}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                />
              }
              label="PBA"
            />
            <FormControlLabelStyle
              onChange={handelFormChange}
              name="is_structure"
              style={{ color: 'white' }}
              control={
                <CheckboxStyle
                  style={{ margin: '0px 8px' }}
                  checked={form.is_structure}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                />
              }
              label="Structure"
            />
          </Box>
        </>
      )}
    </>
  )
}

export default VanillaTrade

VanillaTrade.propTypes = {
  sides: PropTypes.object,
  putCall: PropTypes.array,
  fixingSource: PropTypes.object,
  cut: PropTypes.object,
  counterParty: PropTypes.object,
  currencyData: PropTypes.object,
  currencyInitial: PropTypes.object,
  tradingAccountTradersNormalize: PropTypes.object,
  disabledField: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelDateChange: PropTypes.func,
  children: PropTypes.node,
  form: PropTypes.object,
  errors: PropTypes.object,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  checkPrimeBrokerIsRBS: PropTypes.bool
}
